module.exports = __webpack_public_path__ + "img/card.f0debfc4.png";